import { Component, OnInit, ViewChild, NgModule } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/service/api.service';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator, MatTableDataSource, MatDatepickerModule, MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { Select2OptionData } from 'ng-select2';
import {Options} from 'select2';
import * as _moment from 'moment';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { panCard, mobile, email } from '../../service/customValidation';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface StandardElement {
  name: string;
  installment: string;
  amount: string;
  action: any;
}

@Component({
  selector: 'app-adopt',
  templateUrl: './adopt.component.html',
  styleUrls: ['./adopt.component.css']
})
export class AdoptComponent implements OnInit {
  public batchData: Array<Select2OptionData>;
  public desgData: Array<Select2OptionData>;
  deviceList:Array<Select2OptionData>;
  martialList:Array<Select2OptionData>;
  public options: Options;
  displayedColumns: string[] = ['name', 'designation','action'];
  dataSource:MatTableDataSource<StandardElement>=new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isTable=true;
  isForm=true;
  isSuccess=false;
  isError=false;
  isSubmitted=false;
  isDisabled=false;
  message:string='';
  tblLoading=false;
  isAdopt=false;
  itemTotal=0;
  inputFormGroup:FormGroup;
  editData:any=[];
  searching = false;
  searchFailed = false;
  isAdobpt=false;
  searchFailed1=false;
  constructor(private formBuilder:FormBuilder,private api:ApiService,private route:ActivatedRoute,private datepipe:DatePipe) {
    this.inputFormGroup=this.formBuilder.group({
      id:[0],
      studId:['']
    });
  }

  ngOnInit() {
    
  }

  searchUser = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => term.length<2 ?[] :
        this.api.get("donar?name="+term).pipe(
          map(response=>response.data.map((item,index)=>{
            return {name:item.name,id:item.id};
          }))
          )
      ),
      tap(() => this.searching = false)
    )

    formatter = (x: {name: string}) => x.name;
    rFormatter=(x: {name: string}) => x.name;

    searchStudent = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => term.length<2 ?[] :
        this.api.get("searchStudent?name="+term).pipe(
          map(response=>response.data.map((item,index)=>{
            return {name:item.name,id:item.id};
          }))
          )
      ),
      tap(() => this.searching = false)
    )

    formatter1 = (x: {name: string}) => x.name;
    rFormatter1=(x: {name: string}) => x.name;

    selectedUser(item){
    
      this.inputFormGroup.patchValue({id:item.item.id});

    }
    selectedStudent(item){
    
      this.inputFormGroup.patchValue({studId:item.item.id});

    }

    onAdopt(e)
    {
      if(e.target.value=="Yes")
      {
        this.isAdobpt=true;
      }
      else
      {
        this.isAdobpt=false;
      }

    }

  changePage(event)
  {
    event.preventDefault();
    this.isForm=!this.isForm;
    this.isTable=!this.isTable;
    if(this.isTable)
    {
      this.tableRefresh();
    }
  }

  saveForm(form)
  {
    this.isError=false;
    this.isSuccess=false;
    this.isDisabled=true;
    this.isSubmitted=true;
    if(this.inputFormGroup.invalid)
    {
      this.isDisabled=false;
      return false;
    }
    else
    {
      // form.value.dob=this.datepipe.transform(form.value.dob,"dd/MM/yyyy");
      // form.value.doj=this.datepipe.transform(form.value.doj,"dd/MM/yyyy");
      this.api.post(form.value,'saveStudDonar').subscribe(data=>{
        if(data.status)
        {
          this.isSuccess=true;
          this.message=data.message;
        }
        else
        {
          this.isError=true;
          this.message=data.message;
        }

        this.isSubmitted=false;
        this.isDisabled=false;
        this.inputFormGroup.reset();
      },(error)=>{});

    }
  }

  tblItmPageChange(event)
  {
    let start=(event.pageIndex>0)?(event.pageSize*event.pageIndex):event.pageIndex;
    let postData={start:start,length:event.pageSize};
    this.api.get("donar").subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
    },(error)=>{

    });
  }

  tableRefresh()
  {
    this.api.get("donar").subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
    },(error)=>{});
  }


  deleteRecord(id)
  {
    let postData={id:id};
    this.api.post(postData,"deleteDonar").subscribe(data=>{
      this.tableRefresh();
    },(error)=>{

    });
  }

}
